export default __webpack_public_path__ + "static/media/icon-radio-circle.5f642705.svg";